import * as yup from 'yup'

export const createQuestionKeyword = yup.object({
  questionKeyword: yup.string().max(8),
})
